<template>
    <div class="">
        <div class="card-header d-flex justify-content-between">
        <div class="card-title">
          <h3 class="card-label">Danh sách vốn góp cổ đông thực tế</h3>
        </div>
        <div class="card-title d-flex">
          <button class="btn btn-success font-weight-bold mr-2" @click="exportExcel">
            Export excel
          </button>
          <button
              class="font-weight-bold font-size-3  btn btn-primary"
              @click="dialogImport = true"
          >Import
          </button>
        </div>
      </div>
      <div class="card-body bg-white">
        <div class="example mb-10">
          <div class="row">
            <div class="col-md-2">
                <label for="">Thời điểm góp vốn</label>
                <el-date-picker
                    class="w-100"
                    v-model="query.range_date"
                    type="month"
                    placeholder="Chọn tháng"
                >
                </el-date-picker>
            </div>
            <div class="col-md-2">
                <label for="">Khu vực</label>
              <el-select v-model="query.area_id" clearable filterable collapse-tags placeholder="Chọn khu vực" @change="changebranch">
                <el-option
                    v-for="item in areas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md-2">
                <label for="">Văn phòng</label>
              <el-select v-model="query.branch_id" clearable filterable collapse-tags placeholder="Nhập tên, ID văn phòng">
                <el-option
                    v-for="item in branches"
                    :key="item.id"
                    :label="item.name_alias ?? item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="col-md-2">
                <label for="">Cổ đông</label>
            <el-input placeholder="Nhập tên, mã nhân sự" v-model="query.keyword"></el-input>
            <!--end::Form-->
            </div>
            <div class="col-md-2 mt-8">
                <button v-if="!is_disable_search" class=" btn btn-primary font-weight-bold mr-2"
                        @click="searchData">
                  <i class="fa fa-search"></i> Tìm kiếm
                </button>
                <button v-else type="button" disabled
                        class="btn btn-primary spinner spinner-white spinner-left font-weight-bold mr-2">
                  Tìm kiếm
                </button>
            </div>
          </div>
          <div class="example-preview table-responsive overflow-auto mt-6">
            <table :aria-busy="isBusy" class="table table-hover table-bordered table-vertical-center b-table bg-white"
                   style="text-align: center">
                <thead>
                <tr>
                    <th scope="col" class="min-w-30px">Họ tên cổ đông</th>
                    <th scope="col" class="min-w-100px">Mã nhân sự </th>
                    <th scope="col" class="min-w-100px">ID văn phòng</th>
                    <th scope="col" class="min-w-100px">Tên văn phòng</th>
                    <th scope="col" class="min-w-100px">Khu vực</th>
                    <th scope="col" class="min-w-100px">Vùng</th>
                    <th scope="col" class="min-w-120px">Thời điểm góp</th>
                    <th scope="col" class="min-w-120px">Số tiền góp vốn</th>
                    <th scope="col" class="min-w-120px">Phân loại</th>
                    <th scope="col" class="min-w-120px">Thời gian tạo</th>
                    <th scope="col" class="min-w-120px">Hành động</th>
                </tr>
                </thead>
                <tbody v-if="isBusy">
                    <tr role="row" class="b-table-busy-slot" >
                    <td colspan="16" role="cell" class="">
                        <div class="text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                        </div>
                    </td>
                    </tr>
                </tbody>
                <tbody v-else-if="!dataFinance.length">
                    <tr role="row" class="b-table-busy-slot" >
                    <td colspan="16" role="cell" class="">
                        <div class=" my-2">
                        <strong>Không có thông tin </strong>
                        </div>
                    </td>
                    </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(item, index) in dataFinance" :key="index">
                    <td>{{ item.user ? item.user.name : '' }}</td>
                    <td>{{ item.user ? item.user.id + 100000 : '' }}</td>
                    <td>{{ item.branch_id }}</td>
                    <td>{{ item.branch ? item.branch.name_alias ?? item.branch.name : '' }}</td>
                    <td>{{ item.area ? item.area.name : '' }}</td>
                    <td>{{ item.region ? item.region.name : '' }}</td>
                    <td>{{  item.date |formatMonthYear}}</td>
                    <td>{{ item.money |formatPrice}}</td>
                    <td class="text-white">
                      <span v-if="item.action" class="bg-danger py-2 px-4 rounded ">Rút</span>
                      <span v-else class="bg-success py-2 px-4 rounded">Nạp</span>
                    </td>
                    <td>{{ item.created_at |formatDateTimeVietnam }}</td>
                    <td>
                      <a 
                        title="Xóa"
                        @click="deleteFinace(item.id, item.user ? item.user.name : '')"
                        href="javascript:"
                        class="btn btn-xs btn-icon btn-outline-danger ml-2"><i class="fas fa-trash"></i></a>
                    </td>
                  </tr>
      
                </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end bg-white pr-4">
        Tổng số bản ghi : {{ total }}
      </div>
      <div class="edu-paginate mx-auto d-flex text-center justify-content-center bg-white">
        <paginate
            v-model="page"
            :page-count="last_page"
            :page-range="3"
            :margin-pages="1"
            :click-handler="clickCallback"
            :prev-text="'Trước'"
            :next-text="'Sau'"
            :container-class="'pagination b-pagination'"
            :pageLinkClass="'page-link'"
            :next-link-class="'next-link-item'"
            :prev-link-class="'prev-link-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-class="'page-item'"
        >
        </paginate>
      </div>
      <el-dialog title="Import vốn góp" :visible.sync="dialogImport">
            <div class="mb-2">
                <div>
                    <p for="">Bước 1: Tải xuống file mẫu</p>
                    <div>
                        <el-button class="btn btn-primary" @click="exportFileMau">
                            <i class="el-icon-download"></i>
                            Tải xuống
                        </el-button>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <p for="">Bước 2: Tải file excel lên hệ thống</p>
                    <div class="mb-2">
                        <el-upload
                            ref="upload"
                            accept=".xlsx"
                            :limit="1"
                            list-type="text"
                            action=""
                            :file-list="fileList"
                            :on-change="handleChange"
                            :on-remove="handleRemove"
                            :auto-upload="false"
                            :multiple="false"
                        >
                            <el-button size="small" type="warning">
                                <i class="el-icon-upload2"></i>
                                Tải lên
                            </el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogImport = false">Cancel</el-button>
                <el-button :disabled="loadingImport" v-loading="loadingImport" type="success" class="btn btn-success"
                           @click="submitUpload">Xác nhận
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="Lỗi" :visible.sync="logImport" width="70%">
            <div>Hệ thống phát hiện có lỗi trong quá trình import dữ liệu:</div>
            <table class="table" v-loading="loadingImport">
                <thead>
                <tr>
                    <th>STT</th>
                    <th>ID văn phòng</th>
                    <th>ID khu vực</th>
                    <th>ID vùng</th>
                    <th>Mã nhân sự</th>
                    <th>Số tiền góp</th>
                    <th>Thời gian góp</th>
                    <th>Loại</th>
                    <th>Lỗi</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="(item, index) in listDataImport.dataError" :key="index">
                    <td>{{ index++ }}</td>
                    <td>{{ item.id_van_phong }}</td>
                    <td>{{ item.id_khu_vuc }}</td>
                    <td>{{ item.id_vung }}</td>
                    <td>{{ item.ma_nhan_su }}</td>
                    <td>{{ item.so_tien_gop_von }}</td>
                    <td>{{ item.thoi_diem_gop }}</td>
                    <td>{{ item.loai }}</td>
                    <td>
                        <p v-for="(item_prop, index_prop) in item?.error" :key="index_prop">
                            <span class="text-dark">
                                {{ item_prop }}
                            </span>
                        </p>
                    </td>
                </tr>
                </tbody>
            </table>
            <div slot="footer" class="dialog-footer">
                <el-button v-loading="loadingImport" @click="dialogImport = true, logImport= false">Quay lại </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
  GET_DATA_FINACE,
  DELETE_FINACE,
  EXPORT_FILE_DEFAULT_FINACE_TRANSACTION,
  IMPORT_FINACE_TRANSACTION, EXPORT_EXCEL_SHARED
} from "@/core/services/store/finance/financeTransaction.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {mapGetters} from "vuex";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from "moment-timezone";
import {GET_LIST_AREAS} from "@/core/services/store/center/area.module";
import {GET_BRANCHES} from "@/core/services/store/center/branch.module";
import Swal from "sweetalert2";
import {read, utils} from "xlsx";
import {exportExcel, formatMonthYear, formatPrice, removeVietnameseTones} from "@/core/filters";
import {FinanceTransactionModel} from "@/view/pages/finance/model/FinanceTransactionModel";

export default {
    name: "FinanceTransactionIndex",
    components: {
        DatePicker
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    data() {
        return {
            page: 1,
            areas: [],
            range_total_paid: [],
            branches: [],
            status_contract_cancelled: [],
            query: {
                keyword: '',
                range_total_paid: '',
                area_id: '',
                branch_id: '',
                range_date: null,
                status_contract_cancelled: [],
                type: 1,
                tuitionPayment: '',
                month: '',
                year: ''
            },
            is_disable_search: false,
            dataFinance: {},
            isBusy:false,
            month: '',
            year: '',
            last_page: 1,
            date: null,
            dialogImport: false,
            fileList: [],
            disable: false,
            loading: false,
            logImport: false,
            listDataImport: {},
            loadingImport: false,
            total: 0,
            is_export_excel: false,
            dataExport: []
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý vốn góp cổ đông thực tế", route: '#'},
            {title: "Danh sách vốn góp cổ đông thực tế"}
        ]);
        this.getData();
        this.getAreas();
        let lastMonth = moment().format('YYYY-MM-DD');
        this.query.range_date = new Date(lastMonth);

    },
    methods: {
        fileToJson(file) {
            return new Promise((res, rej) => {
                /* Boilerplate to set up FileReader */
                const reader = new FileReader()
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result
                    const wb = read(bstr, {type: 'binary'})
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0]
                    const ws = wb.Sheets[wsname]
                    /* Convert array of arrays */
                    const data = utils.sheet_to_json(ws)

                    res(data);
                }
                reader.onerror = (e) => {
                    rej(e);
                };
                reader.readAsBinaryString(file[0].raw)
            });
        },
        changebranch() {
          this.$store.dispatch(GET_BRANCHES, {area_id: this.query.area_id, all: true}).then((res) => {
            this.branches = res.data;
          });
        },
        getAreas() {
            this.$store.dispatch(GET_LIST_AREAS, {}).then(data => {
                this.areas = data.data;
            });
        },
        getData() {
            this.clickCallback()
            this.callApiGetList()
        },
        clickCallback(obj) {
          if (this.query.range_date) {
            this.month = this.query.range_date.getMonth() + 1;
            this.year = this.query.range_date.getFullYear();
          } else {
            let lastMonth = moment().format('YYYY-MM-DD');
            this.date = new Date(lastMonth);
            this.month = this.date.getMonth() + 1;
            this.year = this.date.getFullYear();
          }
          this.query.month = this.month;
          this.query.year = this.year;

          this.page = obj
          this.$router.push({
            name: 'list-finance-transaction',
            query: {
              page: this.page,
              ...this.query
            }
          })
          this.callApiGetList()
        },
        pushParamsUrl() {
            if (this.query.range_date) {
            this.month = this.query.range_date.getMonth() + 1;
            this.year = this.query.range_date.getFullYear();
          } else {
            let lastMonth = moment().format('YYYY-MM-DD');
            this.date = new Date(lastMonth);
            this.month = this.date.getMonth() + 1;
            this.year = this.date.getFullYear();
          }
          this.query.month = this.month;
          this.query.year = this.year;

          this.$router.push({
            name: 'list-finance-transaction',
            query: {
              page: this.page,
              ...this.query
            }
          })
        },

        callApiGetList() {
          let payload = this.query;
          payload.page = this.page;
            this.$store.dispatch(GET_DATA_FINACE, payload).then((res) => {
              this.dataFinance = res.data.data;
              this.last_page = res.data.last_page;
              this.total = res.data.total;
              this.is_disable_search = false;
            });
        },
        searchData() {
          this.page = 1
          this.is_disable_search = true
          this.pushParamsUrl()
          this.callApiGetList()
        },
        deleteFinace(id, user_name) {
          let text = "Bạn chắc chắn muốn xóa vốn góp của " + user_name;
          console.log(text);
          Swal.fire({
            title: text,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Không",
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire("Xóa", "", "success");
                this.$store.dispatch(DELETE_FINACE, id).then((res) => {
                  this.callApiGetList();
              });
            }
          });
        },

        exportExcel() {
        this.is_export_excel = true
        const HEADER_ROW_EXPORT_FINANCE_SHARED = [
          {
            key: 'name',
            value: 'Họ tên cổ đông',
          },
          {
            key: 'userId',
            value: 'Mã nhân sự',
          },
          {
            key: 'branchId',
            value: 'ID VP',
          },
          {
            key: 'branchName',
            value: 'Văn phòng',
          },
          {
            key: 'size',
            value: 'Size văn phòng',
          },
          {
            key: 'areaId',
            value: 'ID khu vực',
          },
          {
            key: 'areaName',
            value: 'Khu vực',
          },
          {
            key: 'regionId',
            value: 'ID vùng',
          },
          {
            key: 'regionName',
            value: 'Vùng',
          },
          {
            key: 'businessLevel',
            value: 'Bậc hiện tại',
          },
          {
            key: 'date',
            value: 'Thời điểm tăng/giảm',
          },
          {
            key: 'percent',
            value: 'Tăng/giảm cổ phần có GDKV với RSM',
          },
          {
            key: 'percentNoGDKVFirst',
            value: 'Tăng/giảm cổ phần không GDKV',
          },
          {
            key: 'prePercentNoGDKVFirst',
            value: 'Tăng/giảm cổ phần không GDKV có VP đầu tiên',
          },
          {
            key: 'stockValue',
            value: 'Giá trị cổ phần',
          },
        ]
        const payload = {
          date: moment(this.query.range_date).format('YYYY-MM'),
        }
        this.$store.dispatch(EXPORT_EXCEL_SHARED, payload).then((res) => {
          this.dataExport = res.data.map(item => {
            return new FinanceTransactionModel(
                item?.name, item?.user_id, item?.branch_id, item?.branch_name,
                item?.size_office, item?.area_id, item?.area_name, item?.region_id,
                item?.region_name, item?.business_level, item?.date, item?.percent,
                item?.diff_percent, item?.percent_noGDKV, item?.diff_noGDKV,
                item?.percent_noGDKV_first, item?.diff_noGDKV_first, item?.stock_value
            )
          })
          this.is_export_excel = false
          if (res.data.error) {
            this.$bvToast.toast(res.data.message, {
              title: 'Export excel',
              variant: 'danger',
              solid: true
            });
          }
          exportExcel(HEADER_ROW_EXPORT_FINANCE_SHARED, this.dataExport, "Danh sách vốn góp cổ đông thực tế.xlsx", false)
        });
      },
        
        handleChange(file, fileList) {
            this.fileList = fileList
        },
        handleRemove() {
            this.fileList = []
        },
        convertKey(key) {
            let myString = removeVietnameseTones(key);
            let trimmedString = myString.trim();
            let formattedString = trimmedString.replace(/\s+/g, '_');
            return formattedString.toLowerCase()
        },
        submitUpload() {
            if (!this.fileList.length) {
                this.$notify({
                    title: 'Thất bại',
                    message: 'Chưa có file nào được chọn',
                    type: 'error'
                })
            }
            this.fileToJson(this.fileList).then(dataToImport => {
                this.logImport = true;
                this.listDataImport = dataToImport;
                if (!dataToImport.length) {
                    this.$notify({
                          title: 'Thất bại',
                          message: 'File đã chọn chưa có thông tin.',
                          type: 'error'
                      });
                      this.logImport = false;
                      return;
                }
                this.validateData(dataToImport);
                this.loadingImport = true;
                this.$store.dispatch(IMPORT_FINACE_TRANSACTION, this.listDataImport).then((res) => {
                  this.listDataImport = res.data;
                  if (res.data.check == false) {
                    this.$notify({
                      title: 'Không Thành công',
                      message: res.message,
                      type: 'error'
                    })
                    this.loadingImport = false;
                    return;
                  }
                  if(res.data) {
                        this.dialogImport = false;
                        this.logImport = false;
                        this.$notify({
                            title: 'Thành công',
                            message: res.message,
                            type: 'success'
                        })
                        this.fileList = []
                    this.loadingImport = false;
                      this.callApiGetList();
                      return;
                    }
                })
            })
        },
        validateData(dataToImport) {
          dataToImport.map((data) => {
              console.log(data.ma_nhan_su == undefined ? 'Mã nhân sự không hợp lệ' : '', 'ma_nhan_su');
              return data.error = [
                  typeof data.so_tien_gop_von != 'number' && data.so_tien_gop_von != null ? 'Số tiền không hợp lệ.' : '',
                  data.ma_nhan_su == undefined ? 'Thiếu mã nhân sự' : ''
              ];
          });
        },
        exportFileMau() {
            this.$store.dispatch(EXPORT_FILE_DEFAULT_FINACE_TRANSACTION).then((res) => {
                this.$notify({
                    title: 'Thành công',
                    message: res.message,
                    type: 'success'
                })
            }).catch((error) => {
                this.$notify({
                    title: 'Thất bại',
                    message: error.data.message,
                    type: 'error'
                })
            })
        },
    },

    computed: {
        ...mapGetters(["dataRoleDepartment"]),
    },
}
</script>

<style scoped>
.text-dark {
  color: red !important;
}
</style>